<template>
  <div class="w-full flex flex-col md:flex-row"><a
      href="#main-content"
      class="sr-only focus-visible:not-sr-only focus-visible:absolute focus-visible:top-2 focus-visible:left-2 bg-white text-[#A63A1D] px-3 py-2 rounded shadow"
    >Skip to main content</a><nav
      aria-label="Profile sections"
      class="sm:left-0 sm:block sm:fixed sm:top-0 sm:bottom-0 md:left-0 md:block md:relative md:top-0 md:bottom-0 md:overflow-y-auto md:flex-row md:flex-nowrap md:overflow-hidden shadow-xl bg-white flex flex-wrap items-center justify-between relative md:w-80 sm:w-full z-10 py-4 px-6"
    >
      <div
        class="md:flex-col md:items-stretch md:min-h-full md:flex-nowrap px-0 flex flex-wrap items-center justify-between w-full mx-auto"
      >
        <!-- Toggler -->
        <button
          class="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
          type="button"
          aria-label="Open menu"
          aria-controls="profile-menu"
          v-bind:aria-expanded="collapseShow !== 'hidden'"
          title="Open menu"
          v-on:click="toggleCollapseShow('bg-white m-2 py-3 px-6')"
        >
          <i class="fa fa-bars"></i>
        </button>
        <!-- Brand -->
        <p
          class="md:min-w-full text-blueGray-500 text-sm uppercase font-medium block pt-1 pb-1 no-underline"
        >
          {{ profile_data?.last_name }}, {{ profile_data?.first_name }}
        </p>

        <div
          id="profile-menu"
          class="md:flex md:flex-col md:items-stretch md:opacity-100 md:relative md:mt-2 md:shadow-none shadow absolute top-0 left-0 right-0 z-40 overflow-y-auto overflow-x-hidden h-auto items-center flex-1 rounded"
          v-bind:class="collapseShow"
        >
          <!-- Collapse header -->
          <div
            class="md:min-w-full md:hidden block pb-4 mb-4 border-b border-solid border-blueGray-200"
          >
            <div class="flex flex-wrap">
              <div class="w-6/12">
                <p
                  class="md:min-w-full text-blueGray-500 text-lg uppercase font-bold block pt-1 pb-4 no-underline"
                >
                  {{ profile_data?.first_name }}
                  {{ profile_data?.last_name }}
                </p>
              </div>
              <div class="w-6/12 flex justify-end">
                <button
                  type="button"
                  aria-label="Close"
                  title="Close"
                  class="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
                  v-on:click="toggleCollapseShow('hidden')"
                >
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>
          </div>

          <p class="text-xs pb-2 text-gray-600">
            Click below to edit your profile.
          </p>
          <p class="mt-3 text-medium">
            <button
              type="button"
              class="text-gray-500 uppercase cursor-pointer text-left"
              v-bind:aria-current="$route.params.id === 'primary' ? 'page' : null"
              @click="redirect('primary')"
            >
              Primary Details
            </button>
            <!-- <ul class="list-disc text-sm list-inside space-y-2">
                <li>Addresses</li>
                <li>Contacts</li>
                <li>Personal Details</li>
            </ul> -->
          </p>
          <hr />
          <p class="mt-3 text-medium">
            <button
              type="button"
              class="text-gray-500 uppercase cursor-pointer text-left"
              v-bind:aria-current="$route.params.id === 'practice' ? 'page' : null"
              @click="redirect('practice')"
            >
              Practice Details
            </button>
            <!-- <ul class="list-disc text-sm list-inside space-y-2">
                <li>Education</li>
                <li>Credentials</li>
                <li>Attorney Files</li>
            </ul> -->
          </p>
          <hr />
          <p class="mt-3 text-medium">
            <button
              type="button"
              class="text-gray-500 uppercase cursor-pointer text-left"
              v-bind:aria-current="$route.params.id === 'coverage' ? 'page' : null"
              @click="redirect('coverage')"
            >
              Coverages &amp; Practice Areas
            </button>
            <!-- <ul class="list-disc text-sm list-inside space-y-2">
                <li>Attorney Type</li>
                <li>Coverages</li>
                <li>Practice Area</li>
            </ul> -->
          </p>
          <hr />
          <p class="mt-3 text-medium">
            <button
              type="button"
              class="text-gray-500 uppercase cursor-pointer text-left"
              v-bind:aria-current="$route.params.id === 'disclosure' ? 'page' : null"
              @click="redirect('disclosure')"
            >
              Disclosure &amp; Billing
            </button>
            <!-- <ul class="list-disc text-sm list-inside space-y-2">
                <li>Billing Details</li>
                <li>Complaint Details</li>
                <li>Other Confirmations</li>
            </ul> -->
          </p>
        </div>
      </div>
    </nav><main
      id="main-content"
      tabindex="-1"
      aria-label="Profile content"
      class="px-3 mx-auto mt-3 h-auto xl:w-4/5 md:w-3/4 w-full"
    >
      <div class="" v-if="$route.params.id == 'primary'">
        <primary-details :forms="form"></primary-details>
      </div>
      <div class="" v-if="$route.params.id == 'practice'">
        <practice-details :forms="form"></practice-details>
      </div>
      <div class="" v-if="$route.params.id == 'coverage'">
        <coverage-details :forms="form"></coverage-details>
      </div>
      <div class="" v-if="$route.params.id == 'disclosure'">
        <disclosure-details :forms="form"></disclosure-details>
      </div>
    </main></div><div
    v-if="showPopup"
    role="dialog"
    aria-modal="true"
    aria-labelledby="fee-agreement-title"
    class="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50"
  >
      <div class="bg-white p-6 rounded-lg shadow-lg max-w-lg w-full">
        <h2 id="fee-agreement-title" class="text-center text-2xl font-semibold mb-4" style="color: #1f3341;">
          2025 Fee for Services Network Attorney Agreement
        </h2>
        <p class="text-gray-800 font-bold">
          We’re excited to share that U.S. Legal Services has updated and enhanced our Attorney Fee Reimbursement Schedule—designed with you in mind to offer greater overall compensation for the valuable work you do.<br />
          <br />
          The new schedule goes into effect on June 9, 2025. Please note that any matters authorized before that date will be paid based on the prior fee schedule, while all matters assigned and authorized on or after June 9 will follow the updated rates outlined in the below link.<br />
          <br />
          Please click the following link to review and sign the new Fee for Services Network Attorney Agreement and Fee Schedule:
          <a  href="#"
          @click.prevent="handleFeeAgreementClick"
          class="text-blue-600 hover:underline">Click here</a>
        </p>
        <button @click="dismissPopup" class="mx-auto px-4 py-2 bg-[#1f3341] text-white rounded-lg hover:bg-[#1f3341] block">Close</button>
      </div>
    </div>
</template>
<script>
import PracticeDetails from "./PracticeDetails.vue";
import DisclosureDetails from "./DisclosureDetails.vue";
import PrimaryDetails from "./PrimaryDetails.vue";
import CoverageDetails from "./CoverageDetails.vue";
import { mapState } from "vuex";
import { checkFeeAgreementStatus, generateDynamicLink } from '@/utils/feeAgreementPopup';
export default {
  name: "Home",
  data() {
    return {
      showPopup: false,
      collapseShow: "hidden",
      form: {
        stateCount: { CA: 0, Others: 0 },
        lead: {},
        language_fluent: [],
        attorney_type: [],
        practice_county_list: [],
        coveragelist: [],
        remote_consulting: [],
        referral_cont_fee: false,
        credentials: [],
        addresses: [],
        contacts: [],
      },
    };
  },
  computed: {
  ...mapState(["profile_data"]),
  attid() {
      return this.$store._state.data.att_user.data.id;
    },
  },
  components: {
    PracticeDetails,
    DisclosureDetails,
    PrimaryDetails,
    CoverageDetails,
  },
  created() {
    this.$store.watch(
      () => this.$store.state.errors,
      (value) => {
        if (value != null) {
          if (value?.message == "Authorization failed") {
            this.$toast.error(
              "Authorization Token Expired, Please login again!"
            );
            this.$store.dispatch("logout");
            setTimeout(() => {
              this.$router.push({name:'Login'});
            }, 500);
          } else {
            if (value.length > 0) {
              this.$toast.error("Something went wrong, please try again!");
            }
          }
        }
      }
    );
    this.$store.watch(
      () => this.$store.state.is_attorney_updated,
      (value) => {
        if (value == true) {
          this.$toast.success("Attorney updated successfully");

          var list, index;
          list = document.getElementsByClassName("edit-profile");
          for (index = 0; index < list.length; ++index) {
            list[index].classList.add("hidden");
          }
          this.$store.dispatch("resetUpdateAttorneyFlag");
          this.$store.dispatch("getAttProfileData");
          if (this.$route.params.id == "coverage") {
            this.$store.dispatch("getCoverages", this.form.attorney_type);
          }
        }
      }
    );
  },
  async mounted() {
    const attid = this.attid || this.$store.state.profile_data.attid;
    const isSelected = await checkFeeAgreementStatus(this.$store);
    const dismissed = localStorage.getItem('feeAgreementPopupDismissed');
    this.showPopup = !isSelected && !dismissed;
    this.dynamicLink = await generateDynamicLink(attid);
    this.$store.dispatch("getAttProfileData");
  },
  methods: {
    dismissPopup() {
    this.showPopup = false;
    localStorage.setItem('feeAgreementPopupDismissed', 'true');
  },
    handleFeeAgreementClick() {
      // setTimeout(() => {
        // this.logoutUser();
        this.$store.dispatch("logout");
        // window.open(this.dynamicLink);
        window.location.href = this.dynamicLink;
      // }, 500);
    },
    redirect: function(path) {
      this.$router.push(path);
    },
    toggleCollapseShow: function(classes) {
      this.collapseShow = classes;
    },
  },
};
</script>
